export default __webpack_public_path__ + "static/media/grafema_tour-guide-cale-do-oiro_03.d7a4d8db.jpg";